export default __webpack_public_path__ + "static/media/sub-banner-num-5-hover.d42f8b0f.svg";